<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--mypage is-hide">
            <header class="l-header l-header--top">
                <public-page-header />
            </header>
            <section class="l-content-area">
                <div class="l-content">
                    <section class="p-bloc p-bloc--mypage">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">
                                <section class="p-mypage">
                                    <div class="p-mypage__content">
                                        <div class="mypage-content">
                                            <div class="p-mypage__page mypage-bloc">
                                                <div class="mypage-bloc__content">
                                                    <div class="page__bloc page__bloc--terms c-kiyaku">
                                                        <div class="blog-page">
                                                            <article id="post-inner">
                                                                <header class="article-header">
                                                                    <h1>ファミリーマート店舗でのお支払い方法について</h1>
                                                                    <ul class="post-data">
                                                                        <li class="posted"><span
                                                                                class="data-h">POSTED&nbsp;:&nbsp;&nbsp;</span>2014.01.20
                                                                        </li>
                                                                    </ul>

                                                                    <sns-share-links />

                                                                    <div class="eyecatch-img">
                                                                        <span>
                                                                            <img width="860" height="480"
                                                                                src="@/assets/img/static_pages/familymart_eyecatch1.png"
                                                                                class="attachment-w860-h480 size-w860-h480 wp-post-image"
                                                                                alt="convenience-payment-method">
                                                                        </span>
                                                                    </div>
                                                                </header>

                                                                <!-- post -->
                                                                <section class="article-content">
                                                                    <p>hubsynchでは、コンビニ決済をご利用いただけます。 </p>
                                                                    <p>こちらは、ファミリーマート店舗を利用したお支払い方法の説明です。</p>
                                                                    <h4>お支払いの際に必要となるもの</h4>
                                                                    <p>お支払いの際には、「受付番号（11桁）」と「確認番号（6桁）」が必要になります。</p>

                                                                    <h4>お支払い方法</h4>
                                                                    <p>ファミリーマート店舗内に設置されているFamiポート端末を操作していただきます。</p>
                                                                    <p>また、お支払い後に「取扱明細兼受領書」を忘れずにお受取りください。</p>
                                                                    <p>※お支払い方法の各画面等は、実際の画面とは若干異なる場合がございます。予めご了承ください。</p>


                                                                    <h4>ステップ1</h4>
                                                                    <p>Famiポートのトップ画面で「コンビニでお支払い」を選択してください。</p>

                                                                    <p style="text-align: center;"><img
                                                                            class="aligncenter size-full wp-image-659"
                                                                            src="@/assets/img/static_pages/famiport-familymart.jpg"
                                                                            width="500" height="350"></p>
                                                                    <h4>ステップ2</h4>
                                                                    <p>「各種番号をお持ちの方はこちら」を選択してください。</p>
                                                                    <p style="text-align: center;"><img
                                                                            class="aligncenter size-full wp-image-660"
                                                                            alt="lawson"
                                                                            src="@/assets/img/static_pages/famiport-familymart-2.jpg"
                                                                            width="500" height="350"></p>
                                                                    <h4>ステップ3</h4>
                                                                    <p>「番号入力画面に進む」を押してください。</p>
                                                                    <p style="text-align: center;"><img
                                                                            class="aligncenter size-full wp-image-661"
                                                                            alt="familymart"
                                                                            src="@/assets/img/static_pages/famiport-familymart-3.jpg"
                                                                            width="500" height="350"></p>
                                                                    <h4>ステップ4</h4>
                                                                    <p>「受付番号（11桁）」を入力し、「OK」を押してください。</p>
                                                                    <p style="text-align: center;"><img
                                                                            class="aligncenter size-full wp-image-662"
                                                                            alt="circleksunkus"
                                                                            src="@/assets/img/static_pages/famiport-familymart-4.jpg"
                                                                            width="500" height="350"></p>
                                                                    <h4>ステップ5</h4>
                                                                    <p>「確認番号（6桁）」を入力し、「OK」を押してください。</p>
                                                                    <p style="text-align: center;"><img
                                                                            class="aligncenter size-full wp-image-663"
                                                                            alt="ministop"
                                                                            src="@/assets/img/static_pages/famiport-familymart-5.jpg"
                                                                            width="500" height="350"></p>
                                                                    <h4>ステップ6</h4>
                                                                    <p>お支払い方法についてのご注意が表示されます。内容ご確認後、「同意して利用する」を押してください。
                                                                    </p>
                                                                    <p style="text-align: center;"><img
                                                                            class="aligncenter size-full wp-image-664"
                                                                            alt="seicomart"
                                                                            src="@/assets/img/static_pages/famiport-familymart-6.jpg"
                                                                            width="500" height="350"></p>
                                                                    <h4>ステップ7</h4>
                                                                    <p>お客様のお申込内容が表示されますので、内容ご確認後、よろしければ「確認」を押してください。</p>
                                                                    <p style="text-align: center;"><img
                                                                            class="aligncenter size-full wp-image-664"
                                                                            alt="seicomart"
                                                                            src="@/assets/img/static_pages/famiport-familymart-7.jpg"
                                                                            width="500" height="350"></p>
                                                                    <h4>ステップ8</h4>
                                                                    <p>Famiポート端末より「申込券」が発行されます。申込券を持って30分以内にレジにてお支払いください。お支払い後、取扱明細兼受領書を忘れずにお受取りください。
                                                                    </p>
                                                                    <p style="text-align: center;"><img
                                                                            class="aligncenter size-full wp-image-664"
                                                                            alt="seicomart"
                                                                            src="@/assets/img/static_pages/famiport-familymart-8.jpg"
                                                                            width="500" height="350"></p>
                                                                    <h4>ご注意事項</h4>
                                                                    <p>コンビニエンスストア店舗では、30万円を超えるお支払いはできません。</p>
                                                                    <p>ご注文内容に関するお問合せは、お申込をされたショップ（ご購入元）へお問合せください。</p>
                                                                    <p>コンビニエンスストア店舗では、ご注文内容の変更・取消および返金はできません。</p>
                                                                    <div id="btn-contact-wrap"
                                                                        class="btn-wrap company-contact-cta">
                                                                        <p class="txt">ご不明な点がございましたら、お問合せフォームからご連絡ください。
                                                                        </p>
                                                                        <p class="btn"><a href="/contactus"
                                                                                style="color: #fff !important;">お問合せ</a>
                                                                        </p>
                                                                    </div>
                                                                </section>
                                                            </article>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
            <Footer v-if="isLoggedIn"/>
            <PublicFooter v-else/>
        </div>
    </div>
</template>
<script setup>
import PublicPageHeader from "@/components/PublicPageHeader.vue";
import SnsShareLinks from "@/components/SnsShareLinks.vue";
import { ref, onBeforeMount } from "vue";
import { useSessionStore } from "@/stores/sessionStore";
import Footer from "@/components/Footer.vue";
import PublicFooter from "@/components/PublicFooter.vue";

const sessionStore = useSessionStore();
const isLoggedIn = ref(false);
onBeforeMount(async () => {
    isLoggedIn.value = sessionStore.isLoggedIn();
});
</script>